import React, { useEffect, useState } from "react";
import getGender from "../../utils/getGender";
import getExamVersion from "../../utils/getExamVersion";
import { PiBooksBold } from "react-icons/pi";
import BaseEndpoint from "../../endpoints/baseEndpoint";
import StartButton from "../../elements/startButton";
import { useHistory } from "react-router-dom";

export default function Grid({ user, answer }) {
    const router = useHistory();
    const [activeId, setActiveId] = useState(null);
    const [session, setSession] = useState(null);
    const [remains, setRemains] = useState(null);

    useEffect(() => {
        switch (user?.version) {
            case "potential-test":
                setActiveId("pt");
                break;
            case "potensi-kerja":
                BaseEndpoint.instance()
                    .get(`/exam/${user.version}/instruction?token=${user.token}`)
                    .then((response) => {
                        if (response.status === 200) {
                            const items = (response.data || []).map((item) => ({
                                ...item,
                                name: item.version,
                            }));
                            setSession(items);
                            if (items.length > 0) {
                                setActiveId(items[0].id);
                            }
                        }
                    });
                break;
            case "tes-akademik":
                BaseEndpoint.instance()
                    .get(`/exam/${user.version}/instruction?token=${user.token}`)
                    .then((response) => {
                        if (response.status === 200) {
                            const items = (response.data || []).map((item) => {
                                return {
                                    ...item,
                                    name: item.nama_mapel,
                                };
                            });
                            setSession(items);
                            if (items.length > 0) {
                                // Default to first available mapel that hasn't exceeded max_retake
                                const firstAvailable = items.find((it) => {
                                    const completed = it.hasil
                                        ? it.hasil.filter((h) => h.status_pengerjaan === "completed").length
                                        : 0;
                                    const maxRetake = it.max_retake || 1;
                                    return completed < maxRetake;
                                }) || items[0];
                                setActiveId(firstAvailable.id);
                            }
                        }
                    });
                break;
            case "spesial-potential-test":
                BaseEndpoint.instance()
                    .get(`/exam/${user.version}/instruction?token=${user.token}`)
                    .then((response) => {
                        if (response.status === 200) {
                            const payload = response.data || {};
                            const packages = Array.isArray(payload.data)
                                ? payload.data
                                : [];

                            setSession(payload);
                            setActiveId(
                                payload?.token?.spt_package?.id ??
                                payload?.token?.spt_paket?.id ??
                                (packages.length ? packages[0].id : null)
                            );
                        }
                    });
                break;
            default:
                break;
        }

        // Fetch limit data
        BaseEndpoint.instance().get(`/exam/${user.version}/limit?token=${user.token}`).then((response) => {
            if (response.status === 200) {
                setRemains(response.data.remains);
            }
        });
    }, []);

    const setActive = (id) => {
        setActiveId(id);
    };

    const sessionPackages = Array.isArray(session) ? session : session?.data || [];

    const activeItem = sessionPackages.find((item) => item.id === activeId);
    const activeCompletedCount = activeItem?.hasil
        ? activeItem.hasil.filter((h) => h.status_pengerjaan === "completed").length
        : 0;
    const activeMaxRetake = activeItem?.max_retake || 1;
    const canTakeActiveMapel = activeCompletedCount < activeMaxRetake;

    const onStart = () => {
        // Clear any old session/answers for a clean exam attempt
        localStorage.removeItem("session");
        localStorage.removeItem("answer");
        localStorage.removeItem("mapping");
        if (activeId && activeId !== "pt") {
            localStorage.setItem("last_ta_mapel_id", String(activeId));
        }

        const queryParam = activeId && activeId !== "pt" ? `?id=${activeId}` : "";
        router.push("/app/start" + queryParam);
    };

    return (
        <div className="row">
            <div className="col-md-5">
                <h2 className="h4 font-weight-bold mb-4 text-center">
                    Data Peserta Ujian
                </h2>
                <table className="table table-bordered table-sm bg-white shadow-sm">
                    <tbody>
                        <tr>
                            <td className="font-weight-bold" style={{ width: "40%" }}>Nama</td>
                            <td>{user?.nama_lengkap}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold">No. Telepon</td>
                            <td>{user?.no_tlp || "-"}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold">Alamat email</td>
                            <td>{user?.email || "-"}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold">Tempat & Tanggal Lahir</td>
                            <td>{user?.ttl || "-"}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold">Jenis Kelamin</td>
                            <td>{getGender(user?.jenis_kelamin) || "-"}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold">Versi Ujian</td>
                            <td>{getExamVersion(user?.version) || "-"}</td>
                        </tr>
                        {user?.version === "spesial-potential-test" && (
                            <tr>
                                <td className="font-weight-bold">Nama Paket</td>
                                <td>
                                    {session?.token?.spt_paket?.name_manage || "-"}
                                </td>
                            </tr>
                        )}
                        {user?.version === "tes-akademik" && activeItem && (
                            <>
                                <tr className="table-primary">
                                    <td className="font-weight-bold text-primary">Mapel Dipilih</td>
                                    <td className="font-weight-bold text-primary">{activeItem.name}</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bold">Max Kesempatan</td>
                                    <td>{activeMaxRetake} kali</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bold">Sudah Dikerjakan</td>
                                    <td>{activeCompletedCount} kali</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bold">Sisa Kesempatan Mapel</td>
                                    <td className={`font-weight-bold ${canTakeActiveMapel ? "text-success" : "text-danger"}`}>
                                        {Math.max(0, activeMaxRetake - activeCompletedCount)} kali
                                    </td>
                                </tr>
                            </>
                        )}
                        {remains !== null && (
                            <tr>
                                <td className="font-weight-bold">Total Kuota Token</td>
                                <td>{remains} kali</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <StartButton
                    version={user?.version}
                    answer={answer}
                    disabled={
                        user?.version === "potential-test"
                            ? remains === 0
                            : user?.version === "potensi-kerja"
                            ? remains === 0
                            : user?.version === "tes-akademik"
                            ? !canTakeActiveMapel
                            : null === activeId || remains === 0
                    }
                    onStart={onStart}
                    params={{
                        id: activeId,
                        session: sessionPackages,
                    }}
                />
            </div>
            {sessionPackages.length > 0 && (
                <div className="col-md-7 row">
                    <div className="col-12 mb-3">
                        <h4 className="font-weight-bold text-dark mb-1">
                            Pilih Mata Pelajaran Ujian
                        </h4>
                        <small className="text-muted">
                            Klik kartu mapel untuk memilih ujian. Anda dapat mengulang mapel jika nilai belum memuaskan sesuai sisa kesempatan (max retake).
                        </small>
                    </div>
                    {sessionPackages.map((item, index) => {
                        const completedAttempts = item.hasil
                            ? item.hasil.filter((h) => h.status_pengerjaan === "completed").length
                            : 0;
                        const maxRetake = item.max_retake || 1;
                        const canTake = completedAttempts < maxRetake;
                        const isSelected = activeId === item.id;

                        // Find score if available
                        let scoreText = null;
                        if (answer && answer.nilai) {
                            try {
                                const answerData = JSON.parse(answer.nilai);
                                if (answerData && answerData[item.name] !== undefined) {
                                    scoreText = answerData[item.name];
                                }
                            } catch (e) {}
                        }

                        // Determine card border & shadow
                        let borderColor = isSelected ? "#007bff" : (canTake ? "#dee2e6" : "#28a745");
                        let bgColor = isSelected ? "#f0f7ff" : "#ffffff";

                        return (
                            <div key={index} className="col-md-6 mb-3">
                                <div
                                    className="card h-100 shadow-sm"
                                    onClick={() => {
                                        setActive(item.id);
                                    }}
                                    style={{
                                        borderColor: borderColor,
                                        borderWidth: isSelected ? "3px" : "1.5px",
                                        backgroundColor: bgColor,
                                        cursor: "pointer",
                                        transition: "all 0.2s ease-in-out",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <div className="card-body text-center d-flex flex-column justify-content-between p-3">
                                        <div>
                                            {item.icon && (item.icon.includes("/") || item.icon.includes(".")) ? (
                                                <img
                                                    src={item.icon.startsWith("/") ? item.icon : "/" + item.icon}
                                                    alt={item.name}
                                                    className="mb-2"
                                                    style={{ width: "3.5rem", height: "3.5rem", objectFit: "contain" }}
                                                />
                                            ) : item.icon && item.icon.startsWith("fa-") ? (
                                                <div className="mb-2 text-primary">
                                                    <i className={`fas ${item.icon}`} style={{ fontSize: "3rem" }}></i>
                                                </div>
                                            ) : (
                                                <PiBooksBold
                                                    className={isSelected ? "text-primary" : "text-secondary"}
                                                    style={{ fontSize: "3.5rem" }}
                                                />
                                            )}
                                            <h5
                                                className="card-title font-weight-bold mt-2 text-dark w-100"
                                                style={{ fontSize: "0.95rem" }}
                                            >
                                                {item.name}
                                            </h5>
                                        </div>

                                        <div className="mt-3 border-top pt-2">
                                            {scoreText !== null && (
                                                <div className="mb-1">
                                                    <span
                                                        className={`badge ${
                                                            Number(scoreText) >= (item.passing_grade || 70)
                                                                ? "badge-success"
                                                                : "badge-warning text-dark"
                                                        } px-2 py-1`}
                                                        style={{ fontSize: "0.85rem" }}
                                                    >
                                                        Nilai: {scoreText} / 100
                                                    </span>
                                                </div>
                                            )}

                                            <div className="small text-muted mb-2">
                                                Percobaan: <strong>{completedAttempts}</strong> / {maxRetake}
                                            </div>

                                            {completedAttempts === 0 ? (
                                                <span className="badge badge-info px-2 py-1">
                                                    Belum Dikerjakan
                                                </span>
                                            ) : canTake ? (
                                                <span className="badge badge-warning text-dark px-2 py-1">
                                                    <i className="fas fa-redo-alt mr-1"></i> Bisa Ulang ({maxRetake - completedAttempts}x lagi)
                                                </span>
                                            ) : (
                                                <span className="badge badge-success px-2 py-1">
                                                    <i className="fas fa-check mr-1"></i> Selesai
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
